<template>
	<div class="modal modal-satellite fade" id="modal-satellite" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
	  <div class="modal-dialog" role="document">
	    <div class="modal-content">
	      <div class="modal-header">
	        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
	        <img src="../../images/lasddi-logo.png" alt="lasddi logo">
	      </div>
	      <div class="modal-body">
	      	<div class="row">
	      		<div class="col-sm-6">
	        		<h2 class="text-uppercase no-margin">Bienvenido</h2>
	      			<p class="p1">
	      				Suscríbete al newsletter y te regalamos
	      			</p>
	      			<p class="p2">
	      				<span>5%</span> de Descuento
	      			</p>
	      			<p class="text-general">
	      				Cupón válido para compras mínimas de $400 pesos de productos LASDDI. No acumulable con otras promociones. Sólo aplica a productos encontrados en la página www.lasddi.com
	      			</p>
	      			<form class="form-inline" @submit="subscribe">
						<div class="form-group">
							<label class="admin-text" for="email">Email*</label>
							<input type="text" class="admin-input" placeholder="escribe tu email" v-model="email"/>
							<br><br>
				          	<button type="submit" class="btn btn-black btn-responsive left-align">Registrarme</button>
						</div>
					</form>
	      		</div>
	      		<div class="col-sm-6 col-img">
	      			<img src="../../images/silla-negra.png" alt="silla negra">
	      		</div>
	      	</div>
	      </div>
	    </div>
	  </div>
	</div>
</template>

<script>
import { subscribeNewsletter } from '../../store/actions';

export default {
	data () {
		return {
			email: null
		}
	},

	vuex: {
		actions: {
			subscribeNewsletter
		}
	},

	methods: {
		subscribe (e) {
			e.preventDefault();
			this.subscribeNewsletter(this.email);

			if (!this.email)
				return false;

			// Trigger the click to close the modal
			// after subscribe to the newsletter
			$('.close').trigger('click');
			e.target.reset();
		}
	}
}
</script>


// WEBPACK FOOTER //
// Modal-satellite.vue?35d7db3c